<div fxLayout="row" fxLayoutAlign="start center">
    <h6 class="filter-title" fxFlex>
        Area type and areas
        <span
            class="help"
            appHelpContent
            helpContent="Refine data by marine geographic areas using the 'area type' and 'areas' filters. Currently, two marine region types are supported: IHO Sea Areas and FAO Major Fishing Areas (see 'Help' for more details)."
            >?</span
        >
    </h6>
    <span (click)="onResetButtonClick()" class="reset" fx-layout-align="end">Reset</span>
</div>

<div class="filter-group" fxLayout="row">
    <div class="shape-type" [ngClass]="{ active: selectedShapeTypeId === shapeType.id }" (click)="onShapeTypeChange(shapeType)" *ngFor="let shapeType of shapeTypes" fxFlex>
        {{ shapeType.value }}
    </div>
</div>

<div class="filter-group">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px" class="filter-value-selection" (click)="onAreaClick()">
        <div fxFlex>Area</div>
        <div class="count-wrapper">
            <span class="count" (click)="onAreaClick()">{{ areaSelectLabel }}</span>
        </div>
        <div class="help-wrapper">
            <span
                class="help"
                appHelpContent
                helpContent="For each area type, marine areas and nested sub-areas are presented in the popup window on the globe/ map. To filter the data, deselect areas that are not of interest."
                >?</span
            >
        </div>
    </div>
</div>
